/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Certification_Badge_Not_FoundInputs */

const vi_error_certification_badge_not_found = /** @type {(inputs: Error_Certification_Badge_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo chứng nhận không còn trong thư viện. Tải lại trang.`)
};

/**

* @param {Error_Certification_Badge_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_certification_badge_not_found = /** @type {((inputs?: Error_Certification_Badge_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Certification_Badge_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_certification_badge_not_found(inputs)
});